document.addEventListener('DOMContentLoaded', function () {
    console.log("Custom Js is now ready");
    const desktop_slider = document.querySelector('.product-metafields-review-container');
    const mobile_slider = document.querySelector('.product-metafields-review-container.large-hide');

  if (document.querySelectorAll('.product-metafields-review-container').length > 0) {
    var testimonial = new Flickity(desktop_slider, {
        accessibility: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        // setGallerySize: true,
        autoPlay: true,
        // adaptiveHeight: true,
        // contain: true,
    });
  }
  
    

  if (document.querySelectorAll('.product-metafields-review-container.large-hide').length > 0) {
    var mobile_testimonial = new Flickity(mobile_slider, {
        accessibility: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        setGallerySize: true,
        autoPlay: true,
        // adaptiveHeight: true,
        // contain: true,
    });
  }
    


    // const recommendation_slider = document.querySelector('.template-product product-recommendations ul.product-grid');

    // var recommendation = new Flickity(recommendation_slider, {
    //     groupCells: 4,
    //     pageDots: false,
    //     wrapAround: true,
    //     setGallerySize: false,
    //     autoPlay: true
    // });

    // console.log(document.querySelector('.price-item.price-item--regular span.money').text())

    // document.querySelector('variant-selects select').onchange = function (e) {
    //     this.appendChild('<span class="separator"> | </span> <div class="price">"' + document.querySelector('.custom-product-info .price-item span.money').textContent + '"</div>')
    // }

    // setTimeout(() => {

    //     var button = document.getElementById('submitButton')
    //     var text = document.querySelector('.rc-button-group__options label.rc-radio:has(.rc-radio__input:is(:checked)) .price-label ').textContent;
    //     var child = document.createElement('div');

    //     var finalValue = parseInt(document.querySelector('.product-form__quantity input').value) * parseFloat(text.replace("$", ""));

    //     // console.log(parseInt(document.querySelector('.product-form__quantity input').value) * parseFloat(text.replace("$", "")))
    //     child.classList.add('price');
    //     child.textContent = "$" + finalValue.toFixed(2);
    //     console.log(child);
    //     button.appendChild(child)


    // }, 1000);



    setInterval(function () {

        if (document.querySelectorAll('.rc-button-group__options').length > 0) {
            var currentVal = document.querySelectorAll('.rc-button-group__options').length > 0 ? document.querySelector('.rc-button-group__options label.rc-radio.rc-radio--active .price-label ').innerHTML : '';

            // setTimeout(() => {

            var button = document.getElementById('submitButton')
            var text = document.querySelectorAll('.rc-button-group__options').length > 0 ? document.querySelector('.rc-button-group__options label.rc-radio:has(.rc-radio__input:is(:checked)) .price-label ').innerHTML : '';
            var child = document.createElement('div');
            var currentQuantity = document.querySelector('.product-form__quantity input').value;

            if (text != currentVal) {

                var finalValue = parseInt(currentQuantity) * parseFloat(text.replace("$", ""));

                // console.log(parseInt(document.querySelector('.product-form__quantity input').value) * parseFloat(text.replace("$", "")))

                child.classList.add('price');
                child.textContent = "$" + finalValue.toFixed(2);



                if (document.querySelectorAll("button.product-form__submit .price").length > 0) {
                    document.querySelector('.product-form__submit .price').remove()
                    button.appendChild(child)
                } else {
                    button.appendChild(child)
                }

            } else {
                if (parseInt(currentQuantity) <= 1) {
                    child.classList.add('price');
                    child.textContent = text;

                    // button.appendChild(child)

                    if (document.querySelectorAll("button.product-form__submit .price").length > 0) {
                        document.querySelector('.product-form__submit .price').remove()
                        button.appendChild(child)
                    } else {
                        button.appendChild(child)
                    }
                } else {
                    var finalValue = parseInt(currentQuantity) * parseFloat(text.replace("$", ""));

                    // console.log(parseInt(document.querySelector('.product-form__quantity input').value) * parseFloat(text.replace("$", "")))

                    child.classList.add('price');
                    child.textContent = "$" + finalValue.toFixed(2);



                    if (document.querySelectorAll("button.product-form__submit .price").length > 0) {
                        document.querySelector('.product-form__submit .price').remove()
                        button.appendChild(child)
                    } else {
                        button.appendChild(child)
                    }
                }

            }
        } else {
            if (document.querySelectorAll("button.product-form__submit .price").length > 0) {
                var child = document.createElement('div');
                var text = document.querySelector('price-money .money').textContent
                var value = text.replace("$", "")
                var finalValue = parseInt(document.querySelector('.product-form__quantity input').value) * parseFloat(value.replace(",", ""));
                child.classList.add('price');

                child.textContent = "$" + finalValue.toFixed(2);

                console.log("text: " + text)
                console.log("Final value: " + finalValue)

                document.getElementById('submitButton').appendChild(child)
            }
        }




        // }, 1000);
    }, 1000);


  if (document.querySelectorAll('.custom-product-info').length > 0) {
    document.querySelector('.custom-product-info variant-selects select, .custom-product-info .quantity__input').onchange = function (e) {


        setTimeout(() => {

            console.log('Minus and plus, select')


            var button = document.getElementById('submitButton')
            var text = '';
            var child = document.createElement('div');



            if (document.querySelectorAll('.rc-button-group__options').length > 0) {
                text = document.querySelector('.rc-button-group__options label.rc-radio:has(.rc-radio__input:is(:checked)) .price-label ').textContent
            } else {
                text = document.querySelector('price-money .money').textContent;
            }

            var finalValue = parseInt(document.querySelector('.product-form__quantity input').value) * parseFloat(text.replace("$", ""));



            // console.log(text.replace("$", ""))
            child.classList.add('price');
            child.textContent = "$" + finalValue.toFixed(2);

            // button.appendChild(child)

            if (document.querySelectorAll("button.product-form__submit .price").length > 0) {
                console.log()
                document.querySelector('.product-form__submit .price').remove()
                button.appendChild(child)
            } else {
                button.appendChild(child)
            }

        }, 500);

    }
  }
  
    

    // document.querySelector('.product-details .accordion').onclick = function (tab) {
    //     var tabID = tab.getAttribute("data-tab");


    //     var tab_not_active = document.querySelectorAll('.product-details .accordion:not([data-tab="' + tabID + '"]) details')
    //     for (var i = 0; i < tab_not_active.length; i++) {
    //         tab_not_active[i].removeAttribute("open");
    //     }
    // }

    var accordionTab = document.querySelectorAll(".product-details .accordion");
    for (var i = 0; i < accordionTab.length; i++) {
        var accordion = accordionTab[i];
        accordion.onclick = function () {
            var tabID = this.getAttribute("data-tab");

            var tab_not_active = document.querySelectorAll('.product-details .accordion:not([data-tab="' + tabID + '"]) details')
            for (var i = 0; i < tab_not_active.length; i++) {
                tab_not_active[i].removeAttribute("open");
            }
        }
    }




}, false);